<template lang="pug">
    section
        el-row(:gutter="40")
            el-col(:lg="12" :md="12")
                el-form-item(:label="$t('Name')" prop="name")
                    el-input(type="text" v-model="name" maxlength="255" :show-word-limit="true")
                el-form-item(:label="$t('Description')" prop="description")
                    quill-editor(v-model="description" :options="quillConfig")
                el-form-item(:label="$t('Street')" prop="address.street")
                    el-input(v-model="street" maxlength="255" :show-word-limit="true")
                el-row.no-padding(:gutter="20")
                    el-col(:lg="8" :md="8")
                        el-form-item(:label="$t('Zipcode')" prop="address.zipcode")
                            el-input(v-model="zipcode" maxlength="255" :show-word-limit="true")
                    el-col(:lg="16" :md="16")
                        el-form-item(:label="$t('City')" prop="address.city")
                            el-input(v-model="city" maxlength="255" :show-word-limit="true")
                el-form-item(:label="$t('Country')" prop="address.country")
                    el-select.is-full-width(placeholder="" filterable v-model="country" autocomplete="no-fill")
                        el-option(v-for="(label, value) in countryOptions" :key="value" :label="label" :value="value")
            el-col(:lg="12" :md="12")
                .flex-row
                    el-form-item.grow(:label="$t('Category')" prop="category")
                        el-select.is-full-width(
                            placeholder=""
                            v-model="category"
                            valueKey="id"
                        )
                            el-option(
                                v-for="category in categoryOptions"
                                :key="category.id" :label="category.name" :value="category"
                            )
                                .category-option
                                    span.color(:style="`background: ${category.color}`")
                                    span {{ category.name }}
                    el-form-item.colorpicker(:label="$t('Color')" prop="color")
                        el-color-picker(v-model="color")

                el-form-item
                    el-switch(
                        :active-text="$t('Allow bookings')"
                        inactive-color="#ff4949"
                        v-model="booking"
                    )
                el-form-item.grow(v-if="booking" :label="$t('Max. number of bookings per slot')")
                    el-input(v-model="member_limit_per_slot" type="number" min="1")
</template>

<i18n>
{
  "de": {
    "Name": "Titel",
    "Description": "Beschreibung",
    "Color": "Farbe",
    "Allow bookings": "Anmeldungen zulassen",
    "Max. number of bookings per slot": "Maximale Anzahl von Anmeldungen pro Slot",
    "Street": "Straße",
    "Zipcode": "PLZ",
    "City": "Ort",
    "Country": "Land",
    "Category": "Kategorie"
  }
}
</i18n>

<script>

import _ from 'lodash'
// import Vue from 'vue'
import { mapGetters } from 'vuex'

import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import NestedSet from '@/nested-set-lib'
import quillConfig from '@/quill/config'
import store from '@/store'

export default {
    name: 'Main',
    data() {
        quillConfig.modules.link.pages = this.getPageOptions
        return {
            quillConfig,
        }
    },
    computed: {
        color: {
            get() {
                // return _.get(this.form, 'color', '')
                return _.get(this.form, 'color') || _.get(this.form, 'category.color', '')
            },
            set: value => store.commit('ext_eventManager_event/form/color', value)
        },
        name: {
            get() {
                return _.get(this.form, 'name', '')
            },
            set: value => store.commit('ext_eventManager_event/form/name', value)
        },
        description: {
            get() {
                return _.get(this.form, 'description', '')
            },
            set: value => store.commit('ext_eventManager_event/form/description', value)
        },
        booking: {
            get() {
                return _.get(this.form, 'booking', 'none') === 'free'
            },
            set: value => {
                if (value) store.commit('ext_eventManager_event/form/booking', 'free')
                else store.commit('ext_eventManager_event/form/booking', 'none')
            }
        },
        member_limit_per_slot: {
            get() {
                return _.get(this.form, 'member_limit_per_slot', '')
            },
            set: value => store.commit('ext_eventManager_event/form/member_limit_per_slot', value)
        },
        countryOptions() {
            return countries.getNames('de')
        },
        street: {
            get() {
                return _.get(this.form, 'address.street', '')
            },
            set(value) {
                store.commit('ext_eventManager_event/form/street', value)
            }
        },
        zipcode: {
            get() {
                return _.get(this.form, 'address.zipcode', '')
            },
            set(value) {
                store.commit('ext_eventManager_event/form/zipcode', value)
            }
        },
        city: {
            get() {
                return _.get(this.form, 'address.city', '')
            },
            set(value) {
                store.commit('ext_eventManager_event/form/city', value)
            }
        },
        country: {
            get() {
                return _.get(this.form, 'address.country', '')
            },
            set(value) {
                store.commit('ext_eventManager_event/form/country', value)
            }
        },
        category: {
            get() {
                return _.get(this.form, 'category')
            },
            set(value) {
                store.commit('ext_eventManager_event/form/category', value)
            }
        },
        categoryOptions() {
            let options = this.options.category.items
            return options
        },
        // isUpdate() {
        //     return !! _.get(this.form, 'id')
        // },
        ...mapGetters({
            form: 'ext_eventManager_event/form',
            options: 'ext_eventManager_event/options',

            // cms
            activeCms: 'activeCms',
        }),
    },
    methods: {
        getPageOptions() {
            let menus = _.get(this.activeCms, 'config.template.menus', [])
            menus = _.cloneDeep(menus).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))

            const menuOptions = _.get(this.options, 'menu.items') || []
            // const visibleOptgroups = menuOptions.filter(el => el.menuItems.length).length > 1

            let tree = []
            menus.forEach(menu => {
                let dir = { folder: menu.name, children: [] }
                let children = []

                const menuOption = _.find(menuOptions, { key: menu.key })
                let items = _.get(menuOption, 'menuItems', [])

                if (items.length) {
                    items = _.cloneDeep(items)
                    children = NestedSet.createTree(items)
                }

                dir.children = children
                if (children.length) tree.push(dir)
            })

            return tree
        },
    }
}
</script>

<style lang="sass" scoped>
    .el-form-item.colorpicker
        // margin: 0
        ::v-deep
            .el-form-item__content
                height: 36px
    .flex-row
        display: flex
        justify-content: space-between
        .grow
            flex-grow: 1
            margin-right: 1rem
    .category-option
        .color
            width: 12px
            height: 12px
            border-radius: 50%
            display: inline-block
            margin-right: 6px
            border: 1px solid $--border-color-base
            position: relative
            bottom: -1px
            margin-left: -8px
</style>
